import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { applicationRouteNames } from '../../../app/application-route-names';
import { PermissionsHelper } from '../../../app/helpers/permissions.helper';
import { MpsUser } from '../../../app/models/mps-user.model';
import { MpsUserService } from '../../services/mps-user.service';

export const CampaignManagementGuard = () => {
  const router = inject(Router);
  const userService = inject(MpsUserService);
  const loggedInUser = userService.getUser();

  if (!loggedInUser) {
    return router.navigateByUrl(applicationRouteNames.home);
  }

  const user = new MpsUser(loggedInUser);
  return user && PermissionsHelper.canAccessCampaignManagement(user)
    ? true
    : router.navigateByUrl(applicationRouteNames.home);
};
